module.exports = __webpack_public_path__ + "static/media/makeexport.b322e5d5.png";